import React, { useEffect, useRef } from "react";

interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export const LegalModal: React.FC<LegalModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="legal-modal-overlay" onClick={onClose}>
      <div 
        className="legal-modal-container" 
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="legal-modal-title"
      >
        <header className="legal-modal-header">
          <h1 id="legal-modal-title">{title}</h1>
          <button 
            className="legal-modal-close" 
            onClick={onClose}
            aria-label="닫기"
          >
            &times;
          </button>
        </header>
        <div className="legal-modal-body">
          {children}
        </div>
        <footer className="legal-modal-footer">
          <button className="legal-modal-confirm" onClick={onClose}>
            확인
          </button>
        </footer>
      </div>
    </div>
  );
};
